
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { TeamActions } from '~/store/team/detail'
import { EnterpriseTeam, EnterpriseUser } from '~/types/types'

export default defineComponent({
  name: 'RemoveUserFromTeamButton',
  props: {
    orgUser: {
      type: Object as PropType<EnterpriseUser>,
      required: true
    },
    team: {
      type: Object as PropType<EnterpriseTeam>,
      required: true
    }
  },
  data() {
    return {
      showRemoveUserFromTeamConfirm: false,
      isRemovingUser: false
    }
  },
  methods: {
    ...mapActions('team/detail', {
      removeTeamMember: TeamActions.REMOVE_MEMBER
    }),
    showConfirm() {
      this.showRemoveUserFromTeamConfirm = true
    },
    async removeUser(ownerId: string, email: string) {
      this.isRemovingUser = true
      await this.removeTeamMember({ ownerId, email })
      this.$emit('refetch')
      this.isRemovingUser = false
    }
  }
})
